import { RangeHorizon } from '@chart/types/resample.types';
import { Chip } from '@design/components/chip/Chip';
import React from 'react';

import styles from './ChipHorizonSelector.module.scss';

export interface ChipHorizonSelectorLocales {
  [RangeHorizon.OneDay]: string;
  [RangeHorizon.OneWeek]: string;
  [RangeHorizon.TwoWeeks]: string;
  [RangeHorizon.OneMonth]: string;
  [RangeHorizon.TwoMonths]: string;
  [RangeHorizon.ThreeMonths]: string;
  [RangeHorizon.SixMonths]: string;
  [RangeHorizon.OneYear]: string;
  [RangeHorizon.ThreeYears]: string;
  [RangeHorizon.FiveYears]: string;
  [RangeHorizon.TenYears]: string;
  [RangeHorizon.Max]: string;
}

export interface ChipHorizonSelectorProps {
  horizonRanges: RangeHorizon[];
  selectedRange: RangeHorizon | null;
  disabledHorizons?: RangeHorizon[];
  onChange: (rangeHorizon: RangeHorizon) => void;
  locales: ChipHorizonSelectorLocales;
}

export const ChipHorizonSelector = ({
  horizonRanges,
  selectedRange,
  onChange,
  disabledHorizons = [],
  locales,
}: ChipHorizonSelectorProps) => {
  return (
    <div
      className={styles.chipHorizonSelectorRoot}
      data-testid="horizon-selector"
    >
      {horizonRanges.map(range => (
        <Chip
          data-testid={`${range}-horizon`}
          key={range}
          label={locales[range]}
          type="choice"
          disabled={disabledHorizons.includes(range)}
          isActive={range === selectedRange}
          onClick={() => onChange(range)}
        />
      ))}
    </div>
  );
};
